import { render, staticRenderFns } from "./complete.vue?vue&type=template&id=45061f03&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45061f03')) {
      api.createRecord('45061f03', component.options)
    } else {
      api.reload('45061f03', component.options)
    }
    module.hot.accept("./complete.vue?vue&type=template&id=45061f03&lang=pug&", function () {
      api.rerender('45061f03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/password/complete.vue"
export default component.exports